import { ContestAttemptStatusTypeTypes } from '../../../types/account/marketing/contestAttemptStatusTypeTypes.ts';

interface IProps {
    status: ContestAttemptStatusTypeTypes;
}

export const ContestAttemptStatusBadge = ({ status }: IProps) => {
    switch (status) {
        case 'in_progress':
            return (
                <span
                    className="justify-self-start inline-flex items-center rounded-full bg-yellow-900/20 px-1.5 py-0.5 text-xs font-medium text-yellow-500 inset-ring inset-ring-yellow-400/20">
                        Rozpoczęty
                </span>);
        case 'pending_review':
            return (
                <span
                    className="justify-self-start inline-flex items-center rounded-full bg-red-900/20 px-1.5 py-0.5 text-xs font-medium text-red-400 inset-ring inset-ring-red-400/20">
                    Do weryfikacji
                </span>
            );
        case 'completed':
            return (
                <span
                    className="justify-self-start inline-flex items-center rounded-full bg-green-900/20 px-1.5 py-0.5 text-xs font-medium text-green-400 inset-ring inset-ring-green-500/20">
                        Ukończone
                </span>);

    }
};